// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1y7m9","content":"styles_content__1da_v","tableWrap":"styles_tableWrap__3ihEQ"};